import { AuthConfig } from 'angular-oauth2-oidc';

const keycloakConfig: AuthConfig = {
  issuer: 'https://login.vastaa.ru/realms/vasta-dev',
  clientId: 'inventory-ui',
  redirectUri: window.location.origin,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: false,
};

export const environment = {
  production: true,
  apiUrl: 'https://inventory.dev.vastaa.ru/api',
  baseHref: '/',
  keycloak: keycloakConfig,
};
